import { LoginManagerLogger } from "../logging/Loggers.js";

let LOGIN_DBG_ENABLED = true;

export const debug = {
    write: (..._args) => {
        
    },
    error: LoginManagerLogger.error,
    enable: (en: boolean) => {
        LOGIN_DBG_ENABLED = en ? true:false;
    }
};
if(LOGIN_DBG_ENABLED) {
    debug.write = LoginManagerLogger.debug.bind(LoginManagerLogger);
}